<template>
  <footer class="foot">
    <div class="w1200">
      <div class="left">
        <p><img :src="LogoList.Logo" alt="" /></p>
        <ul class="flexDiv wow fadeInRight" id="footer_ewm">
          <li v-for="(item, index) in codeData" :key="index">
            <p><img :src="item.Cover" alt="" /></p>
            <span>{{ item.Title }}</span>
          </li>
        </ul>
      </div>
      <div class="right">
        <ul>
          <li>地址：南京市江宁区铜山金铜路2号</li>
          <li>电话：400 809 9055</li>
          <li>招生办邮箱：zsb@jku.cn</li>
          <li>Copyright © 金肯职业技术学院 All rights reserved.</li>
          <li>
            <a href="https://beian.miit.gov.cn/" target="_blank"
              >苏ICP备11073940号-3</a
            >
            <a href="https://beian.mps.gov.cn/#/query/webSearch" target="_blank"
              ><em></em>苏公网安备32011502012155号</a
            >
          </li>
        </ul>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  name: "foot",
  data() {
    return {
      LogoList: [],
      codeData: []
    };
  },
  created() {
    this.LogoList = this.Base.GetDepartmentByDid(260);
    this.codeData = this.Base.GetNewsInfoByCid(5516, true, 1, "", 3);
    // console.log(this.codeData,'codeData')
  }
};
</script>
<style lang="less" scoped>
.foot {
  width: 7.5rem;
  height: 3rem;
  background-color: #0376be;
  padding: 0.25rem 0.3rem 0rem 0.3rem;
  box-sizing: border-box;
  position: relative;
  .left {
    position: relative;
    p {
      width: 3.42rem;
      height: 0.74rem;
      margin: 0;
      img {
        display: block;
        object-fit: contain;
      }
    }
    ul {
      float: right;
      position: absolute;
      right: 0;
      top: 0.15rem;
      margin: 0;
      li {
        width: 1.03rem;
        height: 1.3rem;
        font-size: 0.2rem;
        font-weight: normal;
        font-stretch: normal;
        line-height: 0.28rem;
        letter-spacing: 0rem;
        color: #ffffff;
        margin-right: 0.12rem;
        &:last-child {
          margin-right: 0rem;
        }
        p {
          width: 1.03rem;
          height: 1.03rem;
          img {
            margin: 0;
            width: 1.03rem;
            height: 1.03rem;
            object-fit: cover;
          }
        }
        span {
          display: block;
          font-size: 0.2rem;
          font-weight: normal;
          font-stretch: normal;
          line-height: 0.3rem;
          letter-spacing: 0.02rem;
          color: #ffffff;
          text-align: center;
        }
      }
    }
  }
  .right {
    margin-top: 0.15rem;
    ul {
      text-align: left;
      li {
        font-size: 0.2rem;
        font-weight: normal;
        font-stretch: normal;
        line-height: 0.3rem;
        letter-spacing: 0rem;
        color: #ffffff;
        a {
          margin-right: 0.05rem;
        }
        em {
          display: inline-block;
          width: 0.18rem;
          height: 0.18rem;
          background-image: url(../assets/img/wa.png);
          margin-right: 0.05rem;
          background-size: cover;
          vertical-align: -0.02rem;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/foot.vue